<template>
  <div>
    <!-- Modificatore della variabile act-for per richiedere dati di altre aziende -->
    <!-- associate al referente aziendale -->
    <SwitcherAziende/>

    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem"/>

    <!-- Overlay di caricamento -->
    <CustomOverlay :show="overlay_show" text="Caricamento in corso, attendere...">

      <!-- Card di contenimento di piattapasto -->
      <b-card title="Piattapasto" class="mr-1 ml-1">

        <!-- Alert per segnalare che i settaggi sono incompleti. -->
        <b-alert v-model="incomplete_settings" variant="danger">
          <b-icon icon="exclamation-triangle"></b-icon> <b>Attenzione Settaggi incompleti</b>: si prega di accedere
          al menù <i>Impostazioni</i> e completare i dati mancanti od errati.
        </b-alert>

        <!-- Barra Menù -->
        <!-- L'icona per aprire il manuale viene visualizzata solo per i clienti Repas, -->
        <!-- il solo manuale disponibile è infatti il loro.                              -->
        <b-navbar toggleable="lg" type="light" variant="light">
          <b-navbar-nav>
            <b-nav-item @click="settings_modal_show=true"><font-awesome-icon icon="cog" class="ml-1"/> Impostazioni</b-nav-item>
            <b-nav-item v-if="settings.fornitore === REPAS" :href="repas_manual_url" target="_blank"><font-awesome-icon icon="book" class="ml-1"/> Manuale d'Uso</b-nav-item>
          </b-navbar-nav>
        </b-navbar>

        <!-- Bottoni di azione principali ( caricamento ordine e storico ) -->
        <!-- le classi dei pulsanti sono calcolate dinamicamente sulla base-->
        <!-- del flag che ne identifica lo stato abilitato o disabilitato  -->
        <b-row v-if="action_buttons" class="mt-2">
          <b-col cols="12" md="3" offset-md="3" :class="['mr-md-1','mt-2','pt-2','pb-2','text-center',main_menu_disabled ? 'main-menu-col-disabled':'main-menu-col']">
            <b-link @click="apri_caricamento_ordine()" :disabled="main_menu_disabled" :class="[main_menu_disabled ? 'main-menu-link-disabled':'main-menu-link']">
              <b-icon icon="upload" font-scale="7.5"></b-icon>
              <h4>Nuovo Ordine</h4>
            </b-link>
          </b-col>
          <b-col cols="12" md="3" offset-md="0" :class="['mr-md-1','mt-2','pt-2','pb-2','text-center',main_menu_disabled ? 'main-menu-col-disabled':'main-menu-col']">
            <b-link @click="apri_storico()" :disabled="main_menu_disabled" :class="[main_menu_disabled ? 'main-menu-link-disabled':'main-menu-link']">
              <b-icon icon="files" font-scale="7.5"></b-icon>
              <h4>Stato Ordini</h4>
            </b-link>
          </b-col>
        </b-row>

        <!-- Pagina di caricamento dell'ordine -->
        <CaricamentoOrdine v-if="caricamento_ordine"
                           @backToMainMenu="apri_action_buttons"
                           :incomplete_settings="incomplete_settings"/>

        <!-- Pagina con lo status degli ordini -->
        <StatusOrdini v-if="status_ordini"
                           @backToMainMenu="apri_action_buttons"/>

      </b-card>

      <!-- Modale per settaggi dell'azienda relativamente al buono pasto     -->
      <!-- ed al codice cliente. Il footer dell modale lo nascondiamo        -->
      <!-- perchè dobbiamo dare spazio a pulsante di ok per il setting       -->
      <!-- del buono.                                                        -->
      <!-- La parte relativa al codice cliente la visualizziamo solo se si ha-->
      <!-- un fornitore associato.                                           -->
      <!-- @show: associamo l'attuale valore del buono a quello nella modale -->
      <b-modal v-model="settings_modal_show"
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
                hide-header-close
                size='lg'
                title="Impostazioni" >
        <template v-slot:default="{ cancel }">
          <!-- Valore del buono -->
          <b-form-group
            id="set-buono-group"
            label="Inserisci il valore in euro del buono pasto:"
            label-for="set-buono">
            <b-input-group append="€">
              <b-form-input id="set-buono" v-model="settings.valore_buono" @keyup="check_importo_buono"></b-form-input>
            </b-input-group>
          </b-form-group>
          <!-- Iva percentuale del buono pasto - appare solo se il fornitore è Repas -->
          <!-- E' di default il 4% in tutti gli altri casi anche se il dato non viene usato. -->
          <b-form-group v-if="has_fornitore && settings.fornitore === REPAS"
            id="set-iva-buono-group"
            label="Inserisci l'iva percentuale del buono pasto ( valori ammessi: 0% e 4% ):"
            label-for="set-iva-buono">
            <b-input-group append="%">
              <b-form-input id="set-iva-buono" v-model="settings.iva_buono" @keyup="check_iva_buono"></b-form-input>
            </b-input-group>
          </b-form-group>
          <!-- Codice cliente - solo se ha un fornitore associato  -->
          <b-form-group v-if="has_fornitore && !(settings.fornitore === TODUBA)"
            id="set-cod-cliente-group"
            label="Inserisci il tuo codice cliente:"
            label-for="set-cod-cliente">
            <b-form-input id="set-cod-cliente" v-model="settings.codice_cliente" type="text" placeholder="codice cliente"></b-form-input>
          </b-form-group>
          <div class="text-right">
            <b-button size="sm" @click="salva_settaggi" class="mr-1" variant="primary">Ok</b-button>
            <b-button size="sm" @click="cancel()">Annulla</b-button>
          </div>
        </template>
      </b-modal>

    </CustomOverlay>
  </div>
</template>


<script>
import CustomOverlay from '@/components/CustomOverlay'
import PageTagline from '@/components/PageTagline'
import SwitcherAziende from '@/components/refaziendale/SwitcherAziende.vue'
import CaricamentoOrdine from '@/components/piattapasto/CaricamentoOrdine.vue'
import StatusOrdini from '@/components/piattapasto/StatusOrdini.vue'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'
//import moment from 'moment'

export default {
    name: 'PiattaPasto',
    data () {
        return {
          tagline_elem : [ { text : "Piattapasto", link: "office-piattapasto" } ],

          // Visualizzazione overlay di caricamento
          overlay_show : false,

          // Flag che rendono visibili le varie schermate di lavoro
          action_buttons : true,
          caricamento_ordine: false,
          status_ordini : false,

          // Flag per abilitare/disabilitare i due pulsanti di azione principali.
          // inizialmente è disabilitato, vengono quindi abilitati solo se il caricamento
          // dei settings ha esito positivo ( cioè se esiste a sistema una riga relativa
          // all'azienda impostata dal backoffice )
          main_menu_disabled: true,

          // I settaggi dell'azienda che vengono valorizzati tramite l'apposita modale
          settings : {
            valore_buono : 0,
            iva_buono : 0,
            codice_cliente : null,
            fornitore : null
          },

          // I fornitori possibili che possono essere passati dal
          // backend, corrispondono alle chiavi dell'oggetto PIATTAPASTO_SETTINGS
          // incluso nei settaggi di django.
          // La computed forn_available mette a disposizione un'array dei fornitori
          // possibili.
          PELLEGRINI : 'pellegrini',
          REPAS : 'repas',
          TODUBA : 'toduba',

          // Flag per visualizzare o meno la modale dei settings.
          settings_modal_show : false,

          // Url del manuale repas: visualizzato solo se il fornitore impostato per
          // l'azienda è per l'appunto Repas
          repas_manual_url : "https://userportal.welfarebit.it/media/docs/manuale_repas_piattapasto_rev01.pdf"

        }
    },
    computed : {
      /**
       * Array dei fornitori che possono essere accettati
       */
      forn_available : function () {
        return [ this.PELLEGRINI, this.REPAS, this.TODUBA ];
      },

      /**
       * Computed che definisce una proprietà bool la quale mi dice
       * se per quest'azienda è stato o meno definito un fornitore.
       */
      has_fornitore : function () {
        return this.settings.fornitore === null ? false : true;
      },

      /**
       * Computed che visualizza la modale dei settings incompleti
       */
      incomplete_settings : function () {

        let res = false;

        // Sicuramente deve essere ok il valore del buono sia che sia presente un fornitore o meno
        if ( this.settings.valore_buono <= 0 || this.settings.valore_buono == null ) {
          res = true;
        }

        // Se è presente un fornitore devo controllare anche il codice cliente
        if ( this.has_fornitore && ( this.settings.codice_cliente == '' || this.settings.codice_cliente == null) ) {
          res = true;
        }

        // Se è presente un fornitore e questo è Repas, devo controllare anche che sia impostato il valore iva del buono
        // il quale cmq è impostato di defualt al 4%
        if ( this.has_fornitore && this.settings.fornitore === this.REPAS && ( this.settings.iva_buono < 0 || this.settings.iva_buono == null ) ) {
          res = true;
        }

        return res;
      }
    },
    methods: {
      /**
       * Controlliamo che l'importo in euro del buono immesso nella modale sia nel formato corretto,
       * altrimenti rimuoviamo l'ultimo carattere scritto dall'utente.
       * Verifichiamo anche che il valore del buono sia maggiore di zero altrimenti poniamo l'input del form
       * in uno stato non valido.
       */
      check_importo_buono : function () {
        if ( !generalLib.euro_is_valid( this.settings.valore_buono ) ){
          this.settings.valore_buono = this.settings.valore_buono.slice( 0, this.settings.valore_buono.length - 1 );
        }
      },
      /**
       * Controlliamo che il valore dell'iva del buono immesso nella modale sia nel formato corretto,
       * altrimenti rimuoviamo l'ultimo carattere scritto dall'utente.
       * Il numero deve avere un punto come separatore e solo un decimale dopo la virgola.
       * Al momento comunque al backend vengono accettati solo ben determinati valori dell'iva quindi non dobbiamo
       * controllare altro.
       */
      check_iva_buono : function () {
        let regex = /^\d*(\.\d{0,1})?$/g;
        if ( !regex.test( this.settings.iva_buono ) ){
          this.settings.iva_buono = this.settings.iva_buono.slice( 0, this.settings.iva_buono.length - 1 );
        }
      },
      /**
       * Salva i settaggi immessi nella modale.
       */
      salva_settaggi : function () {

        // Chiudiamo la finestra ed abilitiamo l'overlay
        this.overlay_show = true;
        this.settings_modal_show = false;

        // Se il cliente ha un fornitore associato aggiungiamo anche il codice cliente
        // oltre al valore del buono, se il fornitore è Repas dobbiamo aggiungere anche
        // l'iva del buono, altrimenti il codice cliente e l'iva sono posti a null.
        // Nel caso dell'iva se questa è posta a null, il dato viene comunque impostato
        // lato backend al default del 4%.
        let data_to_send = { valore_buono : this.settings.valore_buono }

        if ( this.has_fornitore ) {
          data_to_send.codice_cliente = this.settings.codice_cliente;

          // Se il fornitore è Repas aggiungiamo anche l'iva del buono
          if ( this.settings.fornitore === this.REPAS ) {
            data_to_send.iva_buono = this.settings.iva_buono;
          }
        } else {
          data_to_send.codice_cliente = null;
        }

        axios.post( apiUrl.piattapastoapi.pp_settings, data_to_send )
        .then( ( response ) => {
          // La richiesta torna un 204_NO_CONTENT
          this.overlay_show = false;
          this.$bvModal.msgBoxOk( 'Valori modificati con successo.' );
        })
        .catch( ( error ) => {
          this.overlay_show = false;
          let mess = "Si è verificato un errore nel salvataggio dei dati, il sistema riporta:"
          generalLib.backend_error_message_box( this, error.response.data, mess );

          // In caso di errore andiamo a ricaricare, e quindi mostrare nella modale se viene riaperta,
          // i dati già a sistema.
          this.carica_settings();
        });
      },
      /**
       * Carica i settings per l'azienda
       */
      carica_settings : function () {
        axios.get( apiUrl.piattapastoapi.pp_settings )
        .then( ( response ) => {
          this.settings.valore_buono = response.data.valore_buono;
          this.settings.iva_buono = response.data.iva_buono;
          this.settings.codice_cliente = response.data.codice_cliente;
          this.settings.fornitore = response.data.fornitore;

          // Attenzione: qui vado a vedere il nome del fornitore
          // caricato, se definito, deve corrispondere ad uno di quelli
          // che ci si aspetta, altrimenti lancio un errore perchè
          // è stato passato un fornitore che l'interfaccia ancora non conosce
          if ( this.settings.fornitore !== null ) {
            let check = this.forn_available.filter( ( val ) => { return val === this.settings.fornitore });
            if ( check.length == 0 ) {
              let error_mess = "Fornitore associato all'azienda sconosciuto: " + this.settings.fornitore;
              console.error( error_mess );
              // Lanciando il reject della promise con l'errore, interviene il catch sotto che
              // non abilita il menù.
              return Promise.reject( new Error( error_mess ) );
            }
          }

          // I dati esistono quindi posso abilitare il menù principale
          this.main_menu_disabled = false;
        })
        .catch( ( error ) => {
          // In caso di errore ribadisco la disabilitazione del menù
          this.main_menu_disabled = true;
        });
      },
      /**
       * Apre la schermata con i bottoni di azione iniziali
       */
      apri_action_buttons : function () {
        this.action_buttons = true;
        this.caricamento_ordine = false;
        this.status_ordini = false;
      },
      /**
       * Apre la schermata per il cariamento dell'ordine
       * cancella qualsiasi file caricato in precedenza nella
       * variabile csvfile
       */
      apri_caricamento_ordine : function () {
        this.action_buttons = false;
        this.caricamento_ordine = true;
        this.status_ordini = false;
      },
      /**
       * Apre la schermata dello storico
       */
      apri_storico : function () {
        this.action_buttons = false;
        this.caricamento_ordine = false;
        this.status_ordini = true;
      }
    },
    created : function () {
      // CARICAMENTO DEI VALORI DI SETTAGGIO:
      // valore del buono pasto e codice cliente
      this.carica_settings();
    },
    components :{
      PageTagline,
      CustomOverlay,
      SwitcherAziende,
      CaricamentoOrdine,
      StatusOrdini
    }
}
</script>


<style scoped>
/* Classi pulsanti principali quando abilitati */
.main-menu-link {
  color: black;
  text-decoration: none;
}
.main-menu-col {
  border: 1px solid #d6d6d6;
  border-radius: 10px;
}
.main-menu-col:hover {
  background-color: #f5f5f5;
}

/* Classi pulsanti principali quando disabilitati */
.main-menu-link-disabled {
  color: #b4b5b8;
  text-decoration: none;
  cursor: no-drop;
}

.main-menu-col-disabled {
  border: 1px solid #d6d6d6;
  border-radius: 10px;
}
.main-menu-col-disabled:hover {
  cursor: no-drop;
}





</style>